import { Routes } from '@angular/router';
import { authGuard, noAuthGuard } from '@app/core/guards/auth/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout';

/**
 * @fileoverview app.routes.ts
 * @description
 * **The Route Map**
 * This file defines the application's routing configuration. Aligns with
 * libs/authentication-portal: signin, home (layout), root redirect, 404.
 * Note that each locale has its own build with a baseHref (e.g., /en-IN/),
 * so routes are relative to that baseHref.
 *
 * ARCHITECTURAL PRINCIPLES:
 * 1. Lazy-loaded feature modules
 * 2. Layout-based route structure (MainLayout under /home)
 * 3. Locale-agnostic routing
 */
export const routes: Routes = [
  {
    path: 'signin',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./features/signin/signin.routes').then(m => m.SIGNIN_ROUTES),
  },
  {
    path: 'reset-password',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./features/signin/signin.routes').then(m => m.SIGNIN_ROUTES),
  },
  {
    path: 'create-account',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./features/create-account/create-account.routes').then(
        m => m.CREATE_ACCOUNT_ROUTES,
      ),
  },
  {
    path: 'passwordless',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./features/signin/passwordless.page').then(
        m => m.PasswordlessPageComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/root-redirect/root-redirect.page').then(
        m => m.RootRedirectPageComponent,
      ),
  },
  {
    path: 'home',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('./features/home/home.routes').then(m => m.HOME_ROUTES),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./features/payments/payments.routes').then(
            m => m.PAYMENTS_ROUTES,
          ),
      },
      {
        path: 'security',
        loadChildren: () =>
          import('./features/security/security.routes').then(
            m => m.SECURITY_ROUTES,
          ),
      },
    ],
  },
  {
    path: 'reset-password-request',
    // Public: approval uses `userId` + `requestToken` in the URL (verify + PATCH),
    // not an authenticated session — do not run authGuard / session check here.
    loadComponent: () =>
      import('./features/reset-password-request/reset-password-request.page').then(
        m => m.ResetPasswordRequestPageComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/page-not-found/page-not-found.page').then(
        m => m.PageNotFoundPageComponent,
      ),
  },
];
